import React, { Component } from 'react';
import './singlepost.css';

class SinglePost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            post:[],
            postImg: []

        };
      }

    componentDidMount() {
        this.getPost();
      }

    componentDidUpdate(){
        const url = window.location.href;
        var currentSlug = url.split('/')[4];
        currentSlug = currentSlug.toLowerCase();
        var previousID = null;
        if(this.state.post[0]){
            previousID = this.state.post[0].slug
        } else{
            previousID = null;
        }
        if(currentSlug !== previousID){
        this.getPost();
        }
      }
    
    // componentDidUpdate(){
    //     this.getPost();
    // }
      // Retrieves the list of items from the Express app
      getPost = () => {
        const url = window.location.href;
        var currentSlug = url.split('/')[4];
        currentSlug = currentSlug.toLowerCase();
        console.log(currentSlug)
        fetch(('/api/singlepost/post?'+currentSlug))
        .then(res => res.json())
        .then(data => this.setState({
                    post: data.post,
                    postImg: data.postImg }));

      }

      prettyDate(dateString){
        var date = new Date(dateString);
        var d = date.getDate();
        var m = date.getMonth()+1;
        var y = date.getFullYear();
        return d+'.'+m+'.'+y;
    }

    render() {
        const { post } = this.state;
        const {postImg } = this.state;

        
        return (
            <div className='articleFull fullWidth'>
                {post.length ? (
                    <div>
                        {/* Render the list of items */}
                        {post.map((post, i) => {
                        return(
                           
                                <div className="articleFull fullWidth" key={i+1}>
                                    {postImg.length ? (
                                            <div className="bgCover bgCoverHeight headerBG fullWidth" style={{backgroundImage: `url(${postImg[0].imgURL})`}} >
                                            </div>
                                        
                                    ):(
                                            <div className="articleTopFiller marginTopStart fullWidth"></div>

                                    )}
                                    <h1 className="smallLeadB fullStage marginBotSmall">{post.headline}</h1>
                                    <div className="articleInfo fullStage clearBoth marginBotSmall">
                                        <p className="resourceAuthor boldT floatLeft upperT marginRightSmall">{post.author}</p>
                                        <p className="numeroText floatLeft">
                                            {this.prettyDate(post.created_at)}   
                                        </p>
                                    </div>
                                    <div className="fullstage hoverRed articleContent" dangerouslySetInnerHTML={{ __html : post.copy }}></div>                      
                                    
                                </div>
                    
                        );
                        })}
                    </div>
                    ) : ( ' ')
                }
            </div>
        )
    }
  }
  
  export default SinglePost;


// WEBPACK FOOTER //
// ./src/components/news/singlepost.js